import React, { useState, useEffect, useRef, useMemo } from "react";
import * as css from "./style.module.less";
import CommonHeader from "../../components/common-header";
import classNames from "classnames";
import { Input, Button, Modal, message, Spin } from "@cloud/atom-ui";
import systemBrowser from "./assets/system-browser.svg";
import weLinkBrowser from "./assets/weLink-browser.svg";
import bannerImg from "./assets/banner.png";
import {
  fetchWecodeAppInfo,
  deleteWecodeAbility,
  updateWecodeAppInfo
} from "./server/index";
import { useDispatch } from "redux-react-hook";
import useMappedState from "@src/utils/useMappedState";
import * as actions from "@src/actions/index";
import history from "@src/utils/history";
import { queryString, getAppPathFromType } from "@src/utils/common";
import config from "../../../../configs/config";
import { abilityType } from '../../utils/utils'

const initAppInfo = {
  mobileUrl: "",
  pcUrl: "",
  openBrowser: 0,
  managementUrl: ""
};

const applicationLight = () => {
  const { appInfo } = useMappedState("root");
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [appConfig, setAppConfig] = useState({ ...initAppInfo });
  const [editAppConfig, setEditAppConfig] = useState({ ...initAppInfo });
  const pageInitRef = useRef(false);
  const type = queryString("type");

  useEffect(() => {
    if (pageInitRef.current || appInfo === undefined) {
      return;
    }
    if (!appInfo?.abilityList?.includes(abilityType.h5)) {
      history.push(
        `/${type}/appdetailV2/addAppCapabilities?id=${appInfo?.aliasName}&type=${type}`
      );
      return;
    }
    fetchWecodeAppInfo(appInfo.aliasName, getAppPathFromType(type))
      .then(res => {
        if (res.status === 1) {
          const { mobileUrlCn, manageUrlCn, pcUrlCn, isOpenSystemBrowser } =
            res.data || {};
          const config = {
            mobileUrl: mobileUrlCn,
            pcUrl: pcUrlCn,
            openBrowser: isOpenSystemBrowser,
            managementUrl: manageUrlCn
          };
          setAppConfig({ ...config });
          setEditAppConfig({ ...config });
        } else {
          message.warning(res.errMsg || "查询轻应用功能基本信息失败");
        }
        pageInitRef.current = true;
      })
      .catch(err => {
        pageInitRef.current = true;
        console.log(err);
      });
  }, [appInfo]);

  const editSave = () => {
    const reg = new RegExp(/^(http:\/\/|https:\/\/)/);
    let dataValidity = {
      flag: true,
      msg: ""
    };
    Object.keys(editAppConfig).forEach(item => {
      if (item.includes("Url")) {
        if (item === "mobileUrl" && !editAppConfig[item]) {
          dataValidity = {
            flag: false,
            msg: "必填项不能为空"
          };
        } else if (editAppConfig[item] && !reg.test(editAppConfig[item]))
          dataValidity = {
            flag: false,
            msg: "地址无效，请重新输入"
          };
      }
    });
    if (dataValidity.flag) {
      updateWecodeInfo();
    } else {
      message.error(dataValidity.msg);
    }
  };

  const updateWecodeInfo = () => {
    const param = {
      appId: appInfo.aliasName,
      isSupportMobile: 1,
      isSupportPC: editAppConfig.pcUrl.trim() ? 1 : 0,
      isOpenSystemBrowser: editAppConfig.openBrowser,
      manageUrlCn: editAppConfig.managementUrl,
      pcUrlCn: editAppConfig.pcUrl,
      mobileUrlCn: editAppConfig.mobileUrl
    };
    updateWecodeAppInfo(param, getAppPathFromType(type))
      .then(res => {
        if (res.status === 1) {
          setAppConfig({ ...editAppConfig });
          setIsEdit(v => !v);
        } else {
          message.warning(res.errMsg || "更新轻应用功能信息失败");
        }
      })
      .catch(err => {
        console.log(err);
        message.warning("更新轻应用功能信息失败");
      });
  };

  const editCancel = () => {
    Modal.confirm({
      content: "是否取消编辑？",
      onOk: () => {
        setIsEdit(v => !v);
        setEditAppConfig({ ...appConfig });
      }
    });
  };

  const deleteWecodeApp = () => {
    deleteWecodeAbility(appInfo.aliasName, getAppPathFromType(type))
      .then(res => {
        if (res.status === 1) {
          dispatch(
            actions.setAppInfo({
              ...appInfo,
              abilityList: appInfo.abilityList?.filter(i => i !== abilityType.h5)
            })
          );
          history.push(
            `/${type}/appdetailV2/addAppCapabilities?id=${appInfo?.aliasName}&type=${type}`
          );
        } else {
          message.warning(res.errMsg || "删除轻应用的应用能力失败");
        }
      })
      .catch(err => {
        console.log(err);
        message.warning("删除轻应用的应用能力失败");
      });
  };

  const urlConfigDom = (isRequire, label, value, configKey, appClass) => {
    let inputHolder = "";
    switch (configKey) {
      case "mobileUrl":
        inputHolder = "输入手机端链接";
        break;
      case "pcUrl":
        inputHolder = "输入PC端链接";
        break;
      case "managementUrl":
        // no-default
        inputHolder =
          "应用的管理端地址，发布为线上版本后，企业租户管理员可以从Welink管理后台登录“应用管理后台”实施管理";
        break;
    }
    let valueDom = <span className={css["value"]}>{value || inputHolder}</span>;
    if (isEdit) {
      valueDom = (
        <Input
          className={css["value-input"]}
          defaultValue={value}
          placeholder={inputHolder}
          onChange={e => {
            setEditAppConfig({
              ...editAppConfig,
              [configKey]: e.target.value
            });
          }}
        />
      );
    }
    return (
      <p className={classNames(css["app-config"], appClass)}>
        <span
          className={classNames(css["label"], {
            [css["require"]]: isRequire
          })}
        >
          {label}
        </span>
        {valueDom}
      </p>
    );
  };

  const openBrowserDom = (label, value) => {
    return (
      <p className={css["open-browser-config"]}>
        <span className={classNames(css["label"])}>{label}</span>
        <div className={css["value"]}>
          <div
            className={classNames(css["card"], {
              [css["active"]]: value === 1
            })}
            onClick={() => {
              if (isEdit) {
                setEditAppConfig({
                  ...editAppConfig,
                  openBrowser: 1
                });
              }
            }}
          >
            <img src={systemBrowser} alt="" />
            <div className={css["card-text"]}>
              <p>系统默认浏览器</p>
              <span>推荐</span>
            </div>
          </div>
          <div
            className={classNames(css["card"], {
              [css["active"]]: value === 0
            })}
            onClick={() => {
              if (isEdit) {
                setEditAppConfig({
                  ...editAppConfig,
                  openBrowser: 0
                });
              }
            }}
          >
            <img src={weLinkBrowser} alt="" />
            <p className={css["card-title"]}>WeLink内置浏览器</p>
          </div>
        </div>
      </p>
    );
  };

  const mainConfigRender = () => {
    if (!pageInitRef.current) {
      return (
        <Spin
          style={{
            width: "100%",
            height: "calc(100% - 107px)",
            display: "flex",
            justifyContent: "center"
          }}
        />
      );
    }
    return (
      <div className={css["main"]}>
        {urlConfigDom(
          true,
          "移动端地址",
          !isEdit ? appConfig.mobileUrl : editAppConfig.mobileUrl,
          "mobileUrl"
        )}
        {urlConfigDom(
          false,
          "PC端地址",
          !isEdit ? appConfig.pcUrl : editAppConfig.pcUrl,
          "pcUrl"
        )}
        {openBrowserDom(
          "打开方式配置",
          !isEdit ? appConfig.openBrowser : editAppConfig.openBrowser
        )}
        {urlConfigDom(
          false,
          "管理后台地址",
          !isEdit ? appConfig.managementUrl : editAppConfig.managementUrl,
          "managementUrl",
          css["last-app-config"]
        )}
        {isEdit && (
          <div className={css["edit-btn"]}>
            <Button type="primary" className={css["save"]} onClick={editSave}>
              保存
            </Button>
            <Button className={css["cancel"]} onClick={editCancel}>
              取消
            </Button>
          </div>
        )}
        <img
          className={css["banner"]}
          src={bannerImg}
          alt=""
          onClick={() => window.open(config.astroZeroUrl, "_blank")}
        />
      </div>
    );
  };

  return (
    <div className={css["container"]}>
      <CommonHeader
        headerStyle={{ marginBottom: "30px" }}
        title="轻应用"
        titleEditShow={!isEdit}
        titleEditClick={() => {
          setEditAppConfig({ ...appConfig });
          setIsEdit(v => !v);
        }}
        showRightBtn={true}
        btnClick={deleteWecodeApp}
        desc={[
          "快速接入已有的或开发网页应用，用户可以通过WeLink客户端免登录快速进入"
        ]}
      />
      {mainConfigRender()}
    </div>
  );
};

export default applicationLight;
